import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center overflow-hidden px-6 py-24" data-id="element-31">
      {/* Abstract kinetic background element */}
      <motion.div className="absolute w-[600px] h-[600px] bg-magenta-500/10 rounded-full blur-3xl pointer-events-none" animate={{
      scale: [1, 1.2, 1],
      x: [0, 50, 0],
      y: [0, -50, 0]
    }} transition={{
      duration: 15,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-32" />
      <motion.div className="absolute w-[500px] h-[500px] bg-cyan-500/10 rounded-full blur-3xl pointer-events-none" animate={{
      scale: [1, 1.3, 1],
      x: [0, -60, 0],
      y: [0, 40, 0]
    }} transition={{
      duration: 18,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-33" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-zinc-900 border border-zinc-800 text-xs font-medium text-zinc-400 mb-8 tracking-wide uppercase" data-id="element-35">
          <span className="w-2 h-2 rounded-full bg-magenta-500 animate-pulse" data-id="element-36" />
          Concept in progress · Domain for sale
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="w-full max-w-3xl mb-4" data-id="element-37">
          <div className="relative" data-id="element-38">
            <img src="https://cdn.magicpatterns.com/uploads/1Fd2Wz966FVyKrjePcRv8N/dance_for_fans_logo.png" alt="Dance for Fans" className="w-full h-auto rounded-2xl" data-id="element-39" />
            {/* Cover the baked-in "2024" in the logo's bottom right corner */}
            <div className="absolute bottom-[3%] right-[3%] w-[20%] h-[14%] rounded-md" style={{
            backgroundColor: '#1a0d2e'
          }} aria-hidden="true" data-id="element-40" />
            <span className="absolute bottom-[4%] right-[4%] text-cyan-300 font-serif tracking-wider text-xs sm:text-sm md:text-base lg:text-lg" style={{
            textShadow: '0 0 8px rgba(103, 232, 249, 0.9), 0 0 16px rgba(103, 232, 249, 0.5)'
          }} data-id="element-41">
              2026 future
            </span>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="font-serif text-2xl md:text-3xl tracking-tight text-zinc-300 mb-4" data-id="element-42">
          danceforfans<span className="text-magenta-500" data-id="element-43">.com</span>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-zinc-400 font-light mb-12 italic font-serif" data-id="element-44">
          A platform in motion.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-45">
          <a href="tel:+13058779092" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-magenta-500 text-white rounded-full font-medium hover:bg-magenta-600 transition-colors w-full sm:w-auto" data-id="element-46">
            <Phone className="w-5 h-5" data-id="element-47" />
            Contact Jose
          </a>
          <a href="tel:+13058779092" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-zinc-900 text-zinc-300 rounded-full font-medium hover:bg-zinc-800 transition-colors w-full sm:w-auto border border-zinc-800" data-id="element-48">
            Call 305-877-9092
          </a>
        </motion.div>
      </div>
    </section>;
}